import React from "react";
import { getblog } from "../../modules/Graphql/bloggraphql";
import Layout from "../../container";
import {
  Container,
  Grid,
  GridRow,
  GridColumn,
  Image,
  Card,
  CardContent,
  CardHeader,
  CardDescription,
  Icon,
} from "semantic-ui-react";
import Head from "next/head";
import Router from "next/router";
import { timeAgo, customdecodeURIComponent } from "../../common/Utils";
import { LandingFooter } from "../../pagecomponents/Welcome";

class Blog extends React.Component {
  constructor() {
    super();
    this.state = {
      blogData: [],
      loading: false,
      isMobile: false,
    };
  }

  componentDidMount = () => {
    this.handleWindowSizeChange();
    window.addEventListener("resize", this.handleWindowSizeChange);
    this.getallblogs();
  };

  handleWindowSizeChange = () => {
    this.setState({ isMobile: window.innerWidth <= 767 });
  };
  getallblogs = () => {
    let getdata = {
      start: 0,
      limit: 500,
      orderBy: "id",
      order: "DESC",
      fields: [
        {
          name: "title",
          value: "",
          operator: "!=",
        },
      ],
    };
    getblog(getdata)
      .then((result) => {
        this.setState({
          blogData: result.data.getblog,
          loading: true,
        });
      })
      .catch((error) => {
        console.log("result", error);
      });
  };

  viewBlogDetails = (pageurl) => {
    Router.push(`/blog/${pageurl}`);
  };

  truncateText = (text, maxChars) => {
    if (text?.length > maxChars) {
      return text.slice(0, maxChars) + "...";
    }
    return text;
  };

  render() {
    const { loading, blogData } = this.state;
    return (
      <div className="home-wrapper">
        <Layout>
          <Container fluid style={{ padding: "0em 5em" }}>
            <Head>
              <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0"
              />
              <title>Houseberry: Blog</title>
              <meta
                name="description"
                content="Stay updated with the latest neighborhood rankings, real estate news, tips, and community insights on the Houseberry Blog."
              ></meta>
              <meta
                name="keywords"
                content="real estate blog, neighborhood insights, real estate news, community trends"
              ></meta>
            </Head>
            {loading && (
              <div
                className="homeaccount_main blogmain"
                style={{
                  margin: "0 auto",
                  ...(this.state.isMobile ? {} : { maxWidth: "1280px" }),
                }}
              >
                <h1 className="text-center">Blogs</h1>
                <p className="text-center pb20 tagblog">
                  Unveiling the Charm of Cities, Neighborhoods, and Homes
                </p>
                <Grid>
                  {blogData && blogData.length > 0 ? (
                    <GridRow columns={this.state.isMobile ? 1 : 3}>
                      {blogData.map((item, index) => {
                        return (
                          <GridColumn key={index}>
                            <Card
                              fluid
                              onClick={() => this.viewBlogDetails(item.pageurl)}
                              style={{ marginBottom: "30px" }}
                            >
                              <Image
                                src={item?.featuredimage}
                                alt={item?.title}
                                wrapped
                                ui={false}
                                className="blogImage"
                              />
                              <CardContent>
                                <CardHeader>{item?.title}</CardHeader>
                                <CardDescription>
                                  <div
                                    className="truncate"
                                    // dangerouslySetInnerHTML={{
                                    //   __html: item?.description,
                                    // }}
                                  >
                                    {this.truncateText(
                                      customdecodeURIComponent(
                                        item?.shortdescription
                                      ),
                                      200
                                    )}
                                  </div>
                                </CardDescription>
                              </CardContent>
                              {/* <CardContent extra>
                                <Icon name="time" />
                                {timeAgo(item?.createdtime)}
                              </CardContent> */}
                            </Card>
                          </GridColumn>
                        );
                      })}
                    </GridRow>
                  ) : (
                    <p>No data found</p>
                  )}
                </Grid>
              </div>
            )}
          </Container>
        </Layout>
        <LandingFooter />
      </div>
    );
  }
}

export default Blog;
